<template>
  <div class="d-flex flex-row justify-space-between align-center" style="height: 26px">
    <div class="d-flex flex-row align-center">
      <div v-if="displayViewCounter || displayPublicationTime" class="one-line caption align-center">
        <span v-if="displayPublicationTime">{{ streamedTime }}</span
        ><span v-if="displayPublicationTime && displayViewCounter"> | </span>
        <span v-if="displayViewCounter"> {{ viewsCount }} {{ $t('viewsCounts') }}</span>
      </div>
    </div>
    <v-spacer></v-spacer>
    <!-- <v-btn v-if="downloadBtn" class="mt-2 mr-2" text rounded @click.stop="$emit('onDownload')"><v-icon>mdi-download</v-icon>Download</v-btn> -->
    <!-- read state -->
    <div>
      <!-- Display number of attached documents -->
      <pdf-count v-if="showAttachementCount" :newsItem="item"></pdf-count>
    </div>
    <v-btn text rounded @click.stop.prevent="toggleReadState" :style="readButtonStyle">
      <template v-if="dotRead">
        <v-icon :color="isRead ? 'grey' : theme.unreadBadgeColor" class="align-center"
          >{{ isRead ? 'mdi-checkbox-blank-circle-outline' : 'mdi-checkbox-blank-circle' }}
        </v-icon>
      </template>
      <template v-if="!dotRead">
        <v-icon :color="isRead ? 'success' : theme.unreadBadgeColor" class="align-center">
          {{ isRead ? mx_icons.watchedIcon : mx_icons.unwatchedIcon }}
        </v-icon>
        {{ readTranslation }}
      </template>
    </v-btn>
    <download-dialog v-if="downloadBtn" :downloadFileTitle="downloadFileTitle" @confirmed="$emit('onDownload')"></download-dialog>

    <!-- favorite state -->
    <div class="d-flex align-center ml-3" v-if="showFavorites && favoritesEnabled">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon @click.stop="toggleFavoriteState()" color="gray">
            <v-icon>{{ isFavorite ? mx_icons.favoriteIconActive : mx_icons.favoriteIcon }}</v-icon>
          </v-btn>
        </template>
        <span v-if="isFavorite">{{ $t('remove_from_favorites') }}</span>
        <span v-else>{{ $t('add_to_favorites') }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import index from '../modules/news';
import dateTimeMixin from '@/mixins/dateTimeMixin.js';
import configMixin from '@/mixins/configMixin';
import favoritesService from '@/services/favoritesService';
import readService from '@/services/readService';
import dateUtils from '@/common/dateUtils';
import DownloadDialog from '@/dialogs/DownloadDialog';
import PdfCount from '../modules/news/components/PdfCount';

export default {
  name: 'Subtitle2',
  mixins: [common, dateTimeMixin, configMixin],
  components: {
    DownloadDialog,
    PdfCount,
  },
  props: {
    item: {
      type: Object,
    },
    showFavorites: { type: Boolean, default: true },
    dotRead: { type: Boolean, default: false },
    downloadBtn: { type: Boolean, default: false },
    downloadFileTitle: String,
    displayPublicationTime: { type: Boolean, default: false }, // Anzahl Publikationsdatum
    displayViewCounter: { type: Boolean, default: false }, // Anzahl Aufrufe und Publikationsdatum
    showAttachementCount: { type: Boolean, default: true },
  },
  data() {
    return {
      isFavorite: favoritesService.isFavorite(this.item),
      isRead: readService.isRead(this.item),
      viewsCount: this.item.viewsCount,
    };
  },
  computed: {
    userState() {
      return this.item._userState;
    },
    readButtonStyle() {
      const baseStyle = 'position: relative; overflow: visible;';
      if (this.dotRead) {
        return baseStyle + ' min-width: 48px; min-height: 48px; padding: 12px !important;';
      }
      return baseStyle;
    },

    favoritesEnabled() {
      const instance = this.item.instance;
      if (this.getModuleConfig(index.moduleType, instance)) {
        return this.getModuleConfig(index.moduleType, instance).favoritesEnabled;
      }
      return null;
    },
    streamedTime() {
      const date = new Date(this.item.dateupdated);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      const formattedDate = date.toLocaleDateString(this.$i18n.locale, options);

      return `${this.$t('news.sharedOn')} ${formattedDate}`;
    },
    readTranslation() {
      return this.$t(`${this.isRead ? 'seen' : 'unseen'}.${this.item._moduleId}`);
    },
  },
  methods: {
    toggleFavoriteState() {
      console.debug(' mx_icons.favoriteIcon', this.mx_icons.favoriteIcon);
      console.debug('type', this.item._moduleId);

      let sendboxTitle, snackbarText;
      let type = this.$t(`type.${this.item._moduleId}`); //e.g. type.video or type.news

      const isFavorite = this.isFavorite;
      if (!isFavorite) {
        sendboxTitle = this.item.title;
        snackbarText = this.$t('action.addFavorite.msg', { type, title: this.item.title });
      } else {
        sendboxTitle = this.item.title;
        snackbarText = this.$t('action.removeFavorite.msg', { type, title: this.item.title });
      }

      if (!isFavorite) {
        //no user notification, nor sendbox display
        this.$store.dispatch('sendbox/markAsFavorite2', { item: this.item }, { root: true });
      } else {
        //no user notification, nor sendbox display
        this.$store.dispatch('sendbox/removeFromFavorite2', { item: this.item }, { root: true });
      }

      this.isFavorite = !isFavorite;
    },
    toggleReadState() {
      if (this.item) {
        const isRead = this.isRead;

        let type = this.$t(`type.${this.item._moduleId}`); //e.g. type.video or type.news
        let state = this.$t(`${isRead ? 'unseen' : 'seen'}.${this.item._moduleId}`);
        let actionName = this.$t('action.marked');
        let sendboxTitle = this.item.title;
        let snackbarText = this.$t('markAsMsg', { type, title: this.item.title, state, actionName });

        let action = isRead ? 'markAsUnread2' : 'markAsRead2';

        this.$store.dispatch(
          `sendbox/${action}`,
          {
            item: this.item,
            sendboxTitle,
            snackbarText,
            immediate: true,
          },
          { root: true }
        );
        this.isRead = !isRead;
      }
    },
  },
};
</script>
